export default require('./ClientList').default
